// @flow

import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Loader from '../../partials/Loader'
import SweetAlert from 'sweetalert-react'

import 'sweetalert/dist/sweetalert.css'

require('es6-promise').polyfill()

type Props = {
	children: Object,
};

type State = {
	displayMainLayout: boolean
};

class PublicIndex extends React.Component<Props, State> {
	constructor(props) {
		super(props)

		this.state = {
			displayMainLayout: false
		}
	}

	render() {
		const {
			children,
			globalSweetAlertData
		} = this.props

		return(
      <div>
      	{true ?
      		<div id="public">
		        {children}
				<SweetAlert {...globalSweetAlertData.toJS()} />
		      </div>
		      :
					<Loader />
      	}
      </div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		globalSweetAlertData: state.globalSweetAlertData
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicIndex))
